/**
 * The UTM tagging of the URL a visitor landed on.
 */
export interface VisitUtm {
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
}

/**
 * `utm_medium` values that mark a paid campaign: Google Analytics' paid-channel
 * media, plus native ad networks such as Outbrain.
 */
const PAID_MEDIUM = /^(.*cp.*|ppc|retargeting|paid.*|native)$/i;

/**
 * Meta ads tagged with Meta's `{{placement}}` URL parameter carry the placement
 * (`Instagram_Stories`, `Facebook_Mobile_Feed`) as their medium, so for them the
 * source is what marks the ad.
 */
const META_AD_SOURCE = 'meta';

/**
 * Prefix of client ad campaign names. Pinterest client ads are tagged
 * `utm_medium=social`, the same as organic posts, so the campaign name is what
 * marks them.
 */
const CLIENT_AD_CAMPAIGN_PREFIX = 'clientad_';

/**
 * Whether a visit's UTM tagging marks it as coming from a paid ad.
 *
 * A campaign alone does not: share links, organic posts, emails and ArchiPro AI
 * links all carry `utm_campaign` too.
 */
export function isPaidAdVisit({
    utmSource,
    utmMedium,
    utmCampaign,
}: VisitUtm): boolean {
    if (PAID_MEDIUM.test(utmMedium.trim())) {
        return true;
    }

    if (utmSource.trim().toLowerCase() === META_AD_SOURCE) {
        return true;
    }

    return utmCampaign
        .trim()
        .toLowerCase()
        .startsWith(CLIENT_AD_CAMPAIGN_PREFIX);
}
